<template>
    <fb-default-layout :sidebar-data="sidebarData" :appInfo="appInfo" @logout="handleLogout" @changePassword="$router.push('/update-user-password')" @userCenter="$router.push('/update-user-info')">
        <template slot="footer">

        </template>
    </fb-default-layout>
</template>

<script>

    export default {
        name: "Index",
        components: {},
        data(){
            return {
                appInfo:{},
                sidebarData:[]
            }
        },
        methods:{
            handleLogout(){
                let vm = this;
                vm.$http.post(vm.$api.auth.logout).then(()=>{
                    sessionStorage.removeItem('login-user-info');
                    vm.$router.push('/login');
                })
            }
        },
        created(){
            if(!sessionStorage.getItem('login-user-info')){
                this.$router.push('/login');
            }

            let vm = this;


            vm.appInfo = window.appInfo;



            //加载菜单
            vm.$http.post(vm.$api.auth.menuTree,vm.$qs.stringify({flag:'MENU_SIDEBAR'})).then((resp)=>{

                if(resp.data.status === 200){
                    vm.sidebarData = resp.data.data.menuTree;
                }

            })

        },
        watch:{

        }
    }
</script>

<style lang="scss" scoped>

</style>